<template>
  <div class="content">
    <commonHeader isWhite titleText="Repayment" diyHeaderColor="#fff" :pageTitle="title"></commonHeader>

    <div class="content-box">
      <div class="limitInfo">
        <div class="productInfo">
          <img :src="img" alt="">
          <span>{{ productName }}</span>
        </div>
        <div class="amountTitle">Repayment Amount</div>
        <div class="amount">
          <div class="number" :style="{color: status === '180' ? '#FE5050' : '#4A44C6'}">
            -₹{{ repayAmount?dataMoney(repayAmount):'0' }}
          </div>
          <div class="amountIcon" @click="showBox">
            <img v-if="showingImage" src="@/assets/common/toTop.png" alt="">
            <img v-else src="@/assets/common/toBottom.png" alt="">
          </div>
        </div>
        <div class="box-btn" @click="showLoanRepay">
          Repay now
        </div>
        <div class="repaymentDetails" v-if="showingImage">
          <div class="detailsTitle">Repayment details:</div>
          <div class="detailsInfo" v-for="(item,index) in list" :key="index">
            <div class="infoLeft">{{ item.resume }}</div>
            <div class="infoRight" v-html="item.survival"></div>
          </div>
        </div>
      </div>
      <div class="tipContent">
        <div class="tipItem">
          1. Once your UPI has expired, please return to the repayment page to acquire a new UPI for repayment.
        </div>
        <div class="tipItem">
          2. If the status of your paid order has not been updated, submit proof of payment, and we will handle the payment processing for you.
        </div>
        <div class="tipItem">
          3.You need to obtain upi for each repayment. Please do not repay multiple times with the same upi.
        </div>
        <div class="tipItem">
          Please repay according to the order amount.
        </div>
      </div>
      <div class="uploadUTR">
        <div class="utrTitle">Upload proof of payment</div>
        <van-field
          v-model="userfrom.utr"
          type="digit"
          placeholder="Enter UTR"
          autocomplete="off"
        />
        <van-field
            v-model="userfrom.amount"
            autocomplete="off"
            left-icon=""
            type="digit"
            placeholder="Enter the exact amount of payment"
            @click="addCurrencySymbol"
            @input="inputCurrencySymbol"
            @blur="blurCurrencySymbol"
          >
        </van-field>
      </div>
      <div class="uploadImage">
        <div class="imageTitle">Screenshot proof (optional)</div>
        <div class="bottomImg">
          <div class="Img" v-for="(item,index) in listImg" :key="index">
            <img class="imgItem" :src="item" alt="">
            <img src="@/assets/repayment/off.png" alt="" class="offImg" @click="delImg(index)">
          </div>
          <div class="addImg" @click="addImg" v-if="listImg.length < 3">
            <img src="@/assets/repayment/addImg.png" alt="">
            <p>Add pictures </p>
          </div>
        </div>
        <van-button
          type="primary"
          class="bottom-btn" 
          :disabled="!userfrom.utr||!userfrom.amount"
          :color="!userfrom.utr||!userfrom.amount ? '#DCDCDC' : '#4A44C6'"
          @click="Submit">
          Submit
        </van-button>
      </div>
    </div>
   
    <loanDlog ref="loanDlog"></loanDlog>
    
  </div>
</template>

<script>
import { Toast } from 'vant';
import { base64ToImage } from '@/utils/baseImg'
import loanDlog from '@/components/loanDlog.vue'
import { dataMoney } from '@/utils/money'
import { getAutoApply,getRepaymentDetail,getSettledAutoApply} from "@/views/normalExtension/lib.js"
import {getUpOrderUtr} from '@/http/repayment'
import {getOrderDetails} from '@/views/order/lib'
import commonHeader from '@/components/commonHeader.vue'
export default {
name:'normalExtension',
components:{loanDlog, commonHeader},
data(){
 return{
  checked:false,
  isListVisible:false,
  showingImage:false,
  loading:false,
  productName:'',
  repayAmount:false,
  img:false,
  status:'',
  url:null,
  orderNo:localStorage.getItem('orderNo')||'',
  showAutoApplybtn:false,
  title:'normalExtension',
  listImg: [
  ],
  userfrom: {
    utr: '',
    amount: '',
  },
  list:[]
 }
},
watch:{
  'userfrom.utr': {
    handler (ne, old) {
      console.log(ne,'ne----------');
      if (ne.length >= old.length) {
        this.$managementEvents({ pageName: 'voice', action: 'not', extInfo: {  utr: this.userfrom.utr} })
      }
    }
  },
  'userfrom.amount': {
    handler (ne, old) {
      console.log(ne,'ne----------');
      if (ne.length >= old.length&&ne!=='₹') {
        const amount = this.userfrom.amount.replace(/₹/g, '');
        this.$managementEvents({ pageName: 'voice', action: 'household', extInfo: {  amount: amount} })
      }
    }
  }
},
methods: {
  dataMoney,
  showBox(){
    this.isListVisible = !this.isListVisible
      this.showingImage = !this.showingImage
  },
   //是否展示自动复借按钮接口
 async getAutoApply(){
    const res =await getAutoApply()
    console.log(res,'到期还款页面');
    if(res.same){
      this.showAutoApplybtn=true
    }else{
      this.showAutoApplybtn=false
    }
    
  },
   //根据订单详情判断是否开启复借按钮
 async getOrderDetails(){
  const loadingInstance = Toast.loading(
        {
          message: 'Loading...',
          duration: 0, // 设置为 0 表示持续加载直到手动关闭
          forbidClick: true, // 防止用户点击
          closeOnClick: false // 设置为 true 可以点击关闭 loading
        }
      )
      //订单详情
   const res=await getOrderDetails({
      pageType:2,
      orderNo:this.orderNo,
   })
   console.log(res);
 if(res.authority==='200'){
  loadingInstance.clear()
  this.loading=false
  this.list=res.same.patron
  this.status=res.same.enact
   this.productName=res.same.glad
   this.repayAmount=res.same.dead
   this.img = res.same.dish
   ? base64ToImage(`${'data:image/png;base64,' + res.same.dish}`)
   : require('@/assets/common/defaultOrderImg.png')
   this.checked=res.same.require
   this.$refs.loanDlog.settledAutoApplyAmount=res.same.incorporate
   this.$refs.loanDlog.orderNo=this.orderNo
   this.$managementEvents({ pageName: 'voice', action: 'everything', extInfo: {  type: this.checked, loanOrderId: this.orderNo } })
 }
  },
  async showLoanRepay(){
    const loadingInstance = Toast.loading(
        {
          message: 'Loading...',
          duration: 0, // 设置为 0 表示持续加载直到手动关闭
          forbidClick: true, // 防止用户点击
          closeOnClick: false // 设置为 true 可以点击关闭 loading
        }
      )
    if (this.loadingBtn) return
      this.loadingBtn = true

      const res=await getRepaymentDetail({
      delayTerm: 0,
      orderNo:this.orderNo,
      requestType: 1
     })
    this.url=res.same.deserve[0]?.character
    
    //开启跳到h5还款页面 关闭这显示借款弹窗
      if(!this.showAutoApplybtn ||this.status==='180'){
        this.$router.push({ name: 'easyPay', params: { url: this.url,name:'normalExtension' } })
    
    loadingInstance.clear()
    //  this.url=res.data.repaymentCodeList[0].paymentCode
      }else{
        this.$refs.loanDlog.show=true
        this.$refs.loanDlog.showBtn=true
        this.$refs.loanDlog.url= this.url
        loadingInstance.clear()
        this.$refs.loanDlog.getBankCard()
      }
      setTimeout(() => {
        // 模拟操作完成后的处理
        console.log('操作完成')

        this.loadingBtn = false // 操作完成后将加载状态设置为false，允许下次点击
      }, 1000) // 这里的1000表示操作的耗时，实际情况根据具体操作来确定
   
    },
    // 切换调用是否自动复借接口，开启传true，关闭传false
    async changeSwitch(v){
     console.log(v,"开启");
     this.$managementEvents({ pageName: 'voice', action: 'chase', extInfo: {  type: v, loanOrderId: this.orderNo } })
    await getSettledAutoApply({
      type:v,
      orderNo:this.orderNo,
     })
    //  console.log(res,'开启传true');
  },
    addCurrencySymbol() {
     
      // 当输入框被点击时，如果当前值为空，则添加金额符号
      if (this.userfrom.amount === '') {
        this.userfrom.amount = '₹';
      }
    },
    inputCurrencySymbol(value) {
   
      // 当输入框被点击时，如果当前值为空，则添加金额符号
      if (value === '') {
        this.userfrom.amount = '₹';
      }
      if (value && value.charAt(0) !== '₹') {
        this.userfrom.amount = '₹' + value;
        console.log('触发了');
        //
      }
    },
    blurCurrencySymbol() {
      // 当输入框被点击时，如果当前值为空，则添加金额符号
        if( this.userfrom.amount ==='₹'){
          this.userfrom.amount = '';
      
        }
       
    },
    delImg(index){
      console.log(index);
      this.listImg.splice(index, 1);
    },
    addImg(){
      this.$managementEvents({ pageName: 'voice', action: 'ill', extInfo: '' })
      this.$javaGet('backImg',(res)=>{
        // Toast(`${res[0]}`)
        // console.log(res,'res');
        if(this.listImg.length===2 && res[0].length>1){
          Toast('Only select up to 3 images')
        }else if(this.listImg.length===1 && res[0].length>2){
          Toast('Only select up to 3 images')
        }else if(this.listImg.length===0 && res[0].length>3){
          Toast('Only select up to 3 images')
        }else{
          res[0].forEach(item => {
      this.listImg.push(`data:image/png;base64,${item}`);
    });
        }
        this.$managementEvents({ pageName: 'voice', action: 'green', extInfo: {img: this.listImg} })
      })
    },
    dataURLtoFile(dataurl, filename) { 
        var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    },
   async Submit(){
    this.$managementEvents({ pageName: 'voice', action: 'wash', extInfo: '' })
      const amount = this.userfrom.amount.replace(/₹/g, '');
      const res=await getUpOrderUtr({
       orderNo:this.orderNo,
        utr:this.userfrom.utr,
        img:this.listImg.map(item => this.dataURLtoFile(item)),
        amount:amount
      })
      if(res.authority==='200'){
        Toast('Submit Success')
        this.$managementEvents({ pageName: 'voice', action: 'intimate', extInfo: {  utr: this.userfrom.utr} })
        setTimeout(()=>{
          this.$javaGet('backHome')
        },500)
      }
    },
    showLoan(){
      this.$refs.loanDlog.show=true
      this.$refs.loanDlog.showBtn=false
    }
  

  },

    mounted(){
    this.getAutoApply()
    this.getOrderDetails()
   
  }
  
}
</script>

<style lang="less" scoped>
.content{
  background: #fff;
  padding-top: 55px;
  position:relative;
  min-height: 100vh;
  .content-box{
    width: 100%;
    padding: 0 16px 20px 16px;
    .limitInfo {
      background-color: #EBEBFE;
      border-radius: 10px;
      padding: 16px;
      margin-bottom: 16px;
      .productInfo {
        display: flex;
        align-items: center;
        img {
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
        span {
          color: #000004;
          font-size: 14px;
        }
      }
      .amountTitle {
        color: #4A44C6;
        font-size: 14px;
        margin: 20px 0 16px 0;
      }
      .amount {
        display: flex;
        align-items: center;
        justify-content: center;
        .number {
          color: #4A44C6;
          font-size: 26px;
          font-weight: bold;
        }
        .amountIcon {
          display: flex;
          align-items: center;
          margin-left: 12px;
          img {
            width: 26px;
            height: 26px;
          }
        }
      }
      .box-btn {
        height: 50px;
        background-color: #4A44C6;
        border-radius: 26px;
        color: #FFFFFF;
        font-size: 16px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 16px 0;
      }
      .repaymentDetails {
        .detailsTitle {
          text-align: left;
          color: #000004;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 10px;
        }
        .detailsInfo {
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .infoLeft {
            color: #999999;
            font-size: 14px;
          }
          .infoRight {
            color: #000000;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }
    .tipContent {
      background-color: #FFECEC;
      border-radius: 10px;
      padding: 12px;
      margin-bottom: 16px;
      .tipItem {
        color: #FE5050;
        font-size: 12px;
        text-align: left;
        margin-bottom: 2px;
      }
    }
    .uploadUTR {
      text-align: left;
      margin-bottom: 18px;
      .utrTitle {
        color: #0C0B10;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 12px;
      }
    }
    .uploadImage {
      text-align: left;
      .imageTitle {
        color: #0C0B10;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 12px;
      }
      .bottomImg {
        display: flex;
        .Img {
          width: 88px;
          height: 88px;
          margin-right: 10px;
          position: relative;
          .imgItem {
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }
          .offImg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 30px;
            height: 30px;
          }
        }
        .addImg {
          width: 88px;
          height: 88px;
          border-radius: 10px;
          background-color: #F7F7F7;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 26px;
            height: 26px;
            margin-bottom: 12px;
          }
          p {
            color: #A1A1A1;
            font-size: 12px;
          }
        }
      }
      .bottom-btn {
        width: 100%;
        margin-top: 20px;
        height: 50px;
        border-radius: 26px;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  

}
/deep/ .van-field {
  border: 1px solid #DCDCDC;
  border-radius: 10px;
  margin-bottom: 10px;
  .van-field__control {
    &::placeholder {
      color: #C3C3C3;
    }
  }
}
</style>